import { useState } from "react";
import { Navigate } from "react-router-dom";
import "./Home.css";
const Home = () => {
  const [route, setRoute] = useState("");

  let pageDisplay;
  if (!route) {
    pageDisplay = (
      <div className="homeContainer">
        <div className="headingBox">
          <div className="logoHeading">
            <img src="./images/logo.png" alt="logo" className="logo" />
            <div className="headingTextContainer">
              <h1 className="heading1">The Little Hook Crochet</h1>
              <h1 className="heading2">Yarn Palette Creator</h1>
            </div>
          </div>
        </div>

        <div className="appSelectors">
          <div
            className="routeSelect"
            onClick={() => setRoute("createPatternPalette")}
          >
            <p>Pattern Palette Mixer</p>
          </div>
          <div
            className="routeSelect"
            onClick={() => setRoute("createPalette")}
          >
            <p>Palette Creator</p>
          </div>
        </div>
      </div>
    );
  } else {
    pageDisplay = <Navigate to={`/${route}`} />;
  }

  return pageDisplay;
};

export default Home;
